'use strict';
/**
 * Message that triggers an event remotely for the protocol.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var MUnicast =
/**
   * @param {string} protocolId The identifier of the unicast protocol.
   * @param {string} eventName The name of the event to trigger.
   * @param {object[]} [args] The arguments of the event.
   */
function MUnicast(protocolId, eventName, args) {
  _classCallCheck(this, MUnicast);

  this.pid = protocolId;
  this.event = eventName;
  this.args = args;
  this.type = 'MUnicast';
};

;
module.exports = MUnicast;